import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-image-generation',
  templateUrl: './image-generation.component.html',
  styleUrls: ['./image-generation.component.css']
})
export class ImageGenerationComponent implements OnInit {
  isLoading: boolean;
  providerInfoForm: FormGroup

  constructor(private http: HttpClient, protected $gaService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.$gaService.pageView("/", "Image generation");

    this.providerInfoForm = new FormGroup({
      input_prompt: new FormControl("", [Validators.required]),
      input_token: new FormControl("", [Validators.required]),
    });
  }

  generateImage() {
    this.$gaService.event("generate_image");
    console.log('GenerateImage hitted')
    console.log(this.providerInfoForm.value.input_token)
    console.log(this.providerInfoForm.value.input_prompt)
  }
}
